"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Microsoft = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M14.006076,3 L14.006076,20.1878563 L4,18.0898081 L4,4.93665987 L14.006076,3 Z M20,7 C20.5522847,7 21,7.44771525 21,8 L21,15 C21,15.5522847 20.5522847,16 20,16 L15,16 L15,15 L20,15 L20,9.434 L16,12.1009252 L15.003883,11.4368472 L15.0109712,10.2395169 L16,10.898 L20,8.231 L20,8 L15,8 L15,7 L20,7 Z M9.11536427,8.58790927 C8.41623005,8.58790927 7.85459869,8.87066161 7.43047018,9.43552074 C7.00634167,10.0003799 6.79460019,10.7401839 6.79460019,11.654933 C6.79460019,12.5212655 7.00375946,13.2236274 7.42078688,13.76331 C7.83845986,14.302347 8.37814241,14.5721883 9.04112564,14.5721883 C9.72153881,14.5721883 10.2728413,14.2933092 10.6956787,13.7368423 C11.1185161,13.1803754 11.3302576,12.4470268 11.3296164,11.5374423 C11.3296164,10.6523887 11.1256172,9.93969786 10.7176275,9.39872421 C10.3102834,8.85775055 9.77576528,8.58790927 9.11536427,8.58790927 Z M9.08695992,9.71052644 C9.44201423,9.71052644 9.72153881,9.87707919 9.9261792,10.2101847 C10.1308196,10.5439357 10.232817,11.0106708 10.232817,11.6103898 C10.232817,12.1855778 10.1269463,12.6355284 9.9164959,12.9595962 C9.70604553,13.2836639 9.42071097,13.4456978 9.06113779,13.4456978 C8.71253901,13.4456978 8.43043223,13.2797906 8.21546298,12.9460395 C8.00049374,12.612934 7.89268634,12.1597556 7.89268634,11.5865043 C7.89268634,11.0216452 8.00049374,10.5678212 8.21546298,10.2250324 C8.43043223,9.88224362 8.72157676,9.71052644 9.08695992,9.71052644 Z" })));
};
Microsoft.displayName = 'Microsoft';
exports.default = Microsoft;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Microsoft.js.map